/**
 * @extends com.inq.flash.client.control.messagehandlers.ChatDeniedMessageHandler
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.CMSDKDeniedMessageHandler = function () {
	this.constructor.__super__.call(this);
};
$hxClasses.extend(
	com.inq.flash.client.control.messagehandlers.ChatDeniedMessageHandler,
	com.inq.flash.client.control.messagehandlers.CMSDKDeniedMessageHandler,
	"com.inq.flash.client.control.messagehandlers.CMSDKDeniedMessageHandler"
);

com.inq.flash.client.control.messagehandlers.CMSDKDeniedMessageHandler.prototype.processMessage = function (message) {
	var deniedReason = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_DENIED_REASON);

	if (deniedReason === com.inq.flash.client.data.MessageFields.DATA_CHAT_DENIED_WRONG_REQUEST_FOR_RECONNECT_REASON) {
		this.getController().handleChatLost();

		return;
	}

	this.getController().shutdown(com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_CMSDKDMH);
	this.getController().onNewChatRouterMessage(message);
};
